// redux/store.js
import { configureStore } from "@reduxjs/toolkit";
import menuReducer from "./Slices/menuSlice";
import restaurantReducer from "./Slices/restaurantSlice";
import categoryReducer from "./Slices/categoriesSlice";
import authReducer from "./Slices/authSlice";
import restaurantConfigReducer from "./Slices/restaurantConfigSlice";
import stepReducer from "./Slices/stepSlice";
import restaurantMetadataSlice from "./Slices/restaurantMetadataSlice";
export const store = configureStore({
  reducer: {
    restaurant: restaurantReducer,
    menu: menuReducer,
    category: categoryReducer,
    auth: authReducer,
    restaurantConfig: restaurantConfigReducer,
    step: stepReducer,
    restaurantMetadata: restaurantMetadataSlice,
  },
});

// Optional: Type-safe hooks if you use TypeScript
// export const RootState = store.getState;
// export type AppDispatch = typeof store.dispatch;
